/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmNftMetadataRefreshRequest = {
    ca: string;
    tokenId: string;
    tokenType?: EvmNftMetadataRefreshRequest.tokenType;
};

export namespace EvmNftMetadataRefreshRequest {

    export enum tokenType {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

